module.exports = __webpack_public_path__ + "img/kirby.3ad96bb8.png";